import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import i18n from '../../../i18n'
import {
  TableDateCell,
  TableFileListCell,
  TableRoleCell,
  TableSwitchCell,
  TableTextCell,
} from '../../Table'
import { DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT } from '../DocFlowAddRecipientFields'
import { DocFlowCombiningFieldName } from '../DocFlowCombining'
import {
  DocFlowTableCellBuilding,
  DocFlowTableCellFlat,
  DocFlowTableCellRecipient,
  DocFlowTableCellRecipientStatus,
} from '../DocFlowTableCell'
import { DocFlowTableRowFile } from '../DocFlowTableRowFile'

export function renderCell({
  item,
  name,
  phaseDisabled,
  scrollRef,
  uploadingFiles,
  onClickFile,
  onCombinedDocument,
  ...restProps
}) {
  const { [name]: value } = item
  const recipientValue =
    item[DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]?.[name]

  switch (name) {
    case DocFlowCombiningFieldName.Building:
      return (
        <DocFlowTableCellBuilding
          {...restProps}
          scrollRef={scrollRef}
          value={value}
        />
      )

    case DocFlowCombiningFieldName.Combined:
      return (
        <TableSwitchCell
          {...restProps}
          disabled={phaseDisabled}
          label={
            value
              ? i18n.t('DocumentStapling.MappingTableCombinedTextKey')
              : i18n.t('DocumentStapling.MappingTableNotCombinedTextKey')
          }
          value={value}
          onChange={onCombinedDocument}
        />
      )

    case DocFlowCombiningFieldName.FinalFile:
      return (
        <DocFlowTableRowFile
          {...restProps}
          info={item.is_custom_name}
          infoTooltip='DocumentStapling.FinalFileHasCustomNameTooltipKey'
          item={value}
          tooltip={i18n.t('DocumentStapling.NotCombiningFinalFileTooltipKey')}
          tooltipPosition={FLOATING_ELEMENT_PLACEMENT.top}
          onClickFile={onClickFile}
        />
      )

    case DocFlowCombiningFieldName.Flat:
      return (
        <DocFlowTableCellFlat
          {...restProps}
          item={item}
          scrollRef={scrollRef}
          value={value}
        />
      )

    case DocFlowCombiningFieldName.Uploading:
      return (
        <TableFileListCell
          {...restProps}
          listProps={{
            moreItemsProps: {
              onClickItem: onClickFile,
            },
            onClickItem: onClickFile,
          }}
          scrollRef={scrollRef}
          value={uploadingFiles}
        />
      )

    case DocFlowCombiningFieldName.Role:
      return <TableRoleCell {...restProps} value={recipientValue} />

    case DocFlowCombiningFieldName.Status:
      return (
        <DocFlowTableCellRecipientStatus
          {...restProps}
          value={recipientValue}
        />
      )

    case DocFlowCombiningFieldName.Recipient:
      return <DocFlowTableCellRecipient {...restProps} value={value} />

    case DocFlowCombiningFieldName.Uploaded:
      return <TableDateCell {...restProps} value={value} />

    case DocFlowCombiningFieldName.PagesCount:
      return <TableTextCell {...restProps} value={value} />

    default:
      break
  }
}
